module.exports = "<img src=\"assets/Collage.png\" style=\"display: block; width: 680px; margin: auto;\"/>\n"